import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from '../../core';
import { Message } from './message';
import { environment } from 'environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class MessagesService extends HttpDataService {
  public list: Message[];

  constructor(protected injector: Injector) {
    super(injector, '/mars');
  }

  getFetchUrl() {
    return `${environment.API_URL}/crawler/mars/messages`;
  }

  resolve(): Promise<Message[]> | Message[] {
    if (this.list) {
      return this.list;
    }
    return this.fetch().then((messages) => (this.list = messages));
  }

  create(props: any) {
    const url = `${this.baseUrl}/activities/humanResorcesMessage`;

    return this.postRequest(url, JSON.stringify(props), this.getRequestOptions());
  }

  getQuestion(id: string) {
    const url = `${this.baseUrl}`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }
}
